import { Building2, Bot, Banknote, CreditCard, TrendingUp, ShieldCheck, GraduationCap, LibraryBig, FileText, PenSquare, Users, Bell } from "lucide-react";
import { PublicPage, PageHero, Seo } from "@/components/public/PublicChrome";

const GROUPS = [
  { title: "Launch", items: [
    { icon: Building2, name: "Business Formation Center", desc: "A guided, state-by-state checklist to form your LLC or corporation the right way." },
    { icon: FileText, name: "Document Library", desc: "Bank-grade secure storage with encrypted uploads and short-lived signed download links." },
    { icon: PenSquare, name: "Contracts & Agreements", desc: "Generate agreements from editable templates and sign them electronically." },
  ]},
  { title: "Fund", items: [
    { icon: CreditCard, name: "Business Credit Center", desc: "Build business credit separate from your personal score with net-30 tradelines and a live score." },
    { icon: Banknote, name: "Funding Center", desc: "See your funding-readiness score and loans, grants, and investors matched to your business." },
    { icon: TrendingUp, name: "Progress Tracker", desc: "Track completion across every module so you always know your next best move." },
  ]},
  { title: "Grow", items: [
    { icon: Bot, name: "AI Business Advisor", desc: "A context-aware advisor that reads your progress and tells you exactly what to do next." },
    { icon: GraduationCap, name: "Education & Training", desc: "Founder courses across formation, credit, funding, compliance, marketing and operations." },
    { icon: LibraryBig, name: "Resource Center", desc: "A searchable library of downloadable templates, guides, and checklists." },
    { icon: Users, name: "Client Portal", desc: "Manage clients and relationships from one organized place." },
    { icon: Bell, name: "Notifications", desc: "Stay on top of trial reminders, activity, and important updates." },
    { icon: ShieldCheck, name: "Enterprise Security", desc: "Encryption, access controls, and secure infrastructure protecting your business data." },
  ]},
];

export default function Features() {
  return (
    <PublicPage>
      <Seo title="Features" path="/features" description="Every tool a founder needs: business formation, credit, funding, AI advisor, education, documents, contracts, and more — in one platform." />
      <PageHero eyebrow="Features" title="Everything you need to run your business"
        subtitle="Ten integrated modules that take you from idea to funded, growing company — all in one secure command center." />
      <section className="py-20 px-6">
        <div className="max-w-7xl mx-auto space-y-16">
          {GROUPS.map((g) => (
            <div key={g.title}>
              <div className="flex items-center gap-3 mb-8">
                <span className="text-[#D4AF37] text-xs tracking-[0.2em] uppercase">{g.title}</span>
                <span className="h-px flex-1 bg-white/8" />
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid={`feature-group-${g.title.toLowerCase()}`}>
                {g.items.map((f) => (
                  <div key={f.name} className="fv-card-hover rounded-2xl border border-white/8 bg-[#121214] p-7">
                    <div className="w-12 h-12 rounded-xl bg-[#D4AF37]/10 border border-[#D4AF37]/20 flex items-center justify-center mb-5"><f.icon className="w-6 h-6 text-[#D4AF37]" /></div>
                    <h3 className="font-heading text-xl mb-2">{f.name}</h3>
                    <p className="text-[#A1A1AA] text-sm leading-relaxed">{f.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </PublicPage>
  );
}
